import React from 'react';
import { Check, MessageCircle, Share2 } from 'lucide-react';
import { Button } from '../ui/button';
import { Dialog, DialogContent } from '../ui/dialog';

const BookingCompleteView = ({ isOpen, onClose, bookingResult }) => (
  <Dialog open={isOpen} onOpenChange={onClose}>
    <DialogContent className="max-w-md bg-white border-stone-200 rounded-xl">
      <div className="text-center py-6 sm:py-8">
        <div className="w-16 h-16 sm:w-20 sm:h-20 bg-sage-100 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6">
          <Check size={32} className="text-luxury-green" />
        </div>
        <h2 className="font-display text-xl sm:text-2xl text-luxury-green mb-2">Booking Confirmed</h2>
        <p className="text-sm sm:text-base text-stone-500 font-light mb-4 sm:mb-6 px-2">
          We&apos;ve received your booking request. You&apos;ll receive a confirmation shortly.
        </p>
        
        <div className="bg-bone rounded-xl p-3 sm:p-4 text-left mb-4 sm:mb-6 mx-2 border border-stone-100">
          <p className="font-display text-sm sm:text-base text-luxury-green">{bookingResult.service_name}</p>
          <p className="text-xs sm:text-sm text-stone-600">{bookingResult.booking_date} at {bookingResult.booking_time}</p>
          <p className="text-xs sm:text-sm text-stone-600 capitalize">
            {bookingResult.location.replace('_', ' ')} Location
          </p>
          {bookingResult.discount_applied > 0 && (
            <p className="text-xs sm:text-sm text-amber-600 mt-2">
              {(bookingResult.discount_applied * 100).toFixed(0)}% loyalty discount applied!
            </p>
          )}
        </div>

        <div className="mx-2 mb-4 sm:mb-6">
          <p className="text-xs text-stone-400 uppercase tracking-wider mb-2">Share with friends</p>
          <div className="flex gap-2">
            <Button
              onClick={() => {
                const msg = `Just booked a ${bookingResult.service_name} at Dublin Holistic Massage! ${bookingResult.booking_date} at ${bookingResult.booking_time}.\n\nBook here: https://www.dublinholisticmassages.com`;
                window.open(`https://wa.me/?text=${encodeURIComponent(msg)}`, '_blank');
              }}
              className="flex-1 bg-luxury-green-600 hover:bg-luxury-green-500 text-white rounded-full py-3 text-xs font-medium"
              data-testid="share-booking-whatsapp"
            >
              <MessageCircle size={16} className="mr-2" />
              Share on WhatsApp
            </Button>
            <Button
              onClick={() => {
                const msg = `Just booked a ${bookingResult.service_name} at Dublin Holistic Massage! Book: https://www.dublinholisticmassages.com`;
                if (navigator.share) {
                  navigator.share({ title: 'Dublin Holistic Massage', text: msg });
                } else {
                  navigator.clipboard.writeText(msg);
                }
              }}
              variant="outline"
              className="rounded-full py-3 px-4"
              data-testid="share-booking-copy"
            >
              <Share2 size={16} />
            </Button>
          </div>
        </div>

        <Button onClick={onClose} className="w-full bg-luxury-green hover:bg-luxury-green/90 text-white rounded-full mx-2" style={{maxWidth: 'calc(100% - 16px)'}}>
          Done
        </Button>
      </div>
    </DialogContent>
  </Dialog>
);

export default BookingCompleteView;
